import { formatInTimeZone } from 'date-fns-tz';

/**
 * Qué dice el aviso de la copia de GARRA en Validación (0263-0265, BITACORA §152).
 *
 * La asistencia de GARRA se marca en otra app y llega acá de noche. Si la copia se cae, nadie lo
 * nota mirando la lista: las marcas simplemente no están, y una falta que no se ve no se reclama.
 * Por eso la pantalla dice siempre cuándo fue la última copia buena, y en tono de alerta cuando la
 * base (vista `garra_sync_estado`) dice que algo anda mal.
 */
export interface EstadoCopiaGarra {
  /** Texto armado en la base; null = todo bien (o corriendo ahora). */
  alerta: string | null;
  ultimaOk: string | null;
  ultimasInsertadas: number | null;
}

export interface AvisoCopiaGarra {
  tono: 'neutro' | 'alerta';
  texto: string;
}

const TZ = 'America/Lima';

export function avisoCopiaGarra(e: EstadoCopiaGarra): AvisoCopiaGarra {
  const cuando = e.ultimaOk
    ? `Última copia buena: ${formatInTimeZone(new Date(e.ultimaOk), TZ, 'dd/MM HH:mm')}`
    : 'La copia nunca terminó bien';
  if (e.alerta) return { tono: 'alerta', texto: `${e.alerta}. ${cuando}.` };
  const n = e.ultimasInsertadas ?? 0;
  const nuevas = n === 1 ? '1 marca nueva' : `${n} marcas nuevas`;
  return {
    tono: 'neutro',
    texto: `Marcadas en la app GARRA y copiadas cada noche. ${cuando} (${nuevas}).`,
  };
}
